import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import PropTypes from "prop-types";
import { generateNavigateSlug, navigateTo } from "../../utils";
import CollectionTitle from "../../atoms/CollectionTitle";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { DfpComponent } from "../../ads/dfp-component";
import ShowMoreButton from "../../atoms/ShowMoreButton";
import StoryCard from "./StoryCard";

import "./four-col-four-stories-var-two.m.css";

const FourColumnFourStoriesVarTwo = ({
  config = {},
  collection,
  stories,
  showTime = false,
  showColSeparator = false,
  showStSeparator = false,
  extraProp = "",
  displaySecondRow = true,
  displaySponsorAd = true,
  displayRowTitle = true,
  displayRowSeperator = true,
  isRecipePage = false,
}) => {
  const associatedMetadata = get(collection, ["associated-metadata"], {});

  const showColumnSeparator = associatedMetadata.show_column_separator || showColSeparator || null;
  const showRowSeparator = (associatedMetadata.show_row_separator && displayRowSeperator) || null;
  const showStorySeparator = associatedMetadata.show_story_separator || showStSeparator || null;
  const showTimeStamp = associatedMetadata.show_timestamp || showTime || null;
  const showReadTime = associatedMetadata.show_read_time || showTime || null;
  const showRowTitle = (associatedMetadata.show_row_title && displayRowTitle) || null;
  const enableSponsorAd = (associatedMetadata.enable_sponsor_ad && displaySponsorAd) || null;
  const sponsorAdDetails = associatedMetadata.sponsor_ad_details || null;
  const showMoreStoriesButton = associatedMetadata.show_more_stories_button || null;
  const showSecondRow = (associatedMetadata.show_second_row && displaySecondRow) || null;
  const aspectRatio16to9 = associatedMetadata["hero_image_16:9_aspect_ratio"] | null;
  const showCookTime = associatedMetadata.show_cook_time || showTime || null;
  const adUnitPathBottom = associatedMetadata.ad_unit_path_bottom || null;

  const device = useDeviceType();
  const isMobile = device === "mobile";

  const sectionSlug = extraProp;

  const dispatch = useDispatch();
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const url = generateNavigateSlug(collection, qtConfig);

  const firstRowStories = stories.slice(0, 4);
  const secondRowStories = stories.slice(4, 8);
  const sponsorAdConfig = useSelector((state) => get(state, ["qt", "config", "ads-config", "slots", "sponsor_ad"], {}));
  const bottomAdConfig = useSelector((state) =>
    get(state, ["qt", "config", "ads-config", "slots", "row_bottom_ad"], {})
  );

  if (!stories.length) return null;
  return (
    <div className="container row-component" styleName="top-component-wrapper">
      <div styleName="four-col-four-stories-var-two">
        {showRowTitle && (
          <CollectionTitle
            collection={collection}
            enableSponsorAd={enableSponsorAd}
            sponsorAdDetails={sponsorAdDetails}
            sectionSlug={sectionSlug}
            sponsorAdConfig={sponsorAdConfig}
          />
        )}
        <div styleName={showColumnSeparator ? "story-with-separator" : "story-without-separator"}>
          {firstRowStories.map((story, index) => {
            return (
              <Fragment key={index}>
                <StoryCard
                  story={story}
                  showReadTime={showReadTime}
                  showTimeStamp={showTimeStamp}
                  showCookTime={showCookTime}
                  aspectRatio16to9={aspectRatio16to9}
                  sectionSlug={sectionSlug}
                />
                {isMobile && index === 1 && <div styleName={showStorySeparator ? "separator" : ""}></div>}
                {showColumnSeparator && index !== firstRowStories.length - 1 && <div styleName="divider"></div>}
              </Fragment>
            );
          })}
        </div>
        {showSecondRow && secondRowStories.length > 0 && (
          <div styleName={`${showStorySeparator ? "separator" : ""}`}></div>
        )}

        {showSecondRow && secondRowStories.length > 0 && (
          <div styleName={showColumnSeparator ? "story-with-separator" : "story-without-separator"}>
            {secondRowStories.map((story, index) => {
              return (
                <Fragment key={index}>
                  <StoryCard
                    story={story}
                    showReadTime={showReadTime}
                    showTimeStamp={showTimeStamp}
                    showCookTime={showCookTime}
                    aspectRatio16to9={aspectRatio16to9}
                    sectionSlug={sectionSlug}
                  />
                  {isMobile && index === 1 && <div styleName={showStorySeparator ? "separator" : ""}></div>}
                  {showColumnSeparator && index !== secondRowStories.length - 1 && <div styleName="divider"></div>}
                </Fragment>
              );
            })}
          </div>
        )}

        {stories?.length > 0 && showMoreStoriesButton && (
          <ShowMoreButton
            collection={collection}
            config={config}
            navigate={() => navigateTo(dispatch, url)}
            qtConfig={qtConfig}
            isRecipePage={isRecipePage}
          />
        )}
      </div>
      {showRowSeparator && <div styleName={showRowSeparator ? "row-separator" : "row-separator border-none"}></div>}

      {adUnitPathBottom && (
        <DfpComponent
          adStyleName="ad-slot-size-300x250"
          id={`${collection?.slug}-row-bottom-ad`}
          path={adUnitPathBottom}
          size={bottomAdConfig?.sizes}
          viewPortSizeMapping={bottomAdConfig?.view_port_size_mapping}
        />
      )}
    </div>
  );
};

FourColumnFourStoriesVarTwo.propTypes = {
  collection: PropTypes.shape({
    slug: PropTypes.string,
  }),
  stories: PropTypes.array.isRequired,
  config: PropTypes.object,
  extraProp: PropTypes.string,
};

FourColumnFourStoriesVarTwo.storyLimit = 8;

export default FourColumnFourStoriesVarTwo;
